import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useMsal } from "@azure/msal-react";
import { useLocalStorage } from "../useLocalStorage";
import {  Table,Button,  Form,  InputGroup,  Card,  Modal,  Row,  Col } from "react-bootstrap";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import "./Indicadores.css";

export default function Indicadores() {

  const [nameReport, setnameReport] = useLocalStorage(
    "nameReport",
    null
  );


  const [mostrarModal, setMostrarModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [indicadorEditar, setIndicadorEditar] = useState(null);

  const [mostrarFicha, setMostrarFicha] = useState(false);
  const [indicadorFicha, setIndicadorFicha] = useState(null);

  const { instance } = useMsal();

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();

    if (accounts.length > 0) {
      return accounts[0];
    }

    return null;
  };

  const userAuth = getAccountInfo();

  const user = {
    name: userAuth?.name || "",
    email: userAuth?.username || "",
  };

  const handleLogout = () => {
    instance.logoutRedirect({});
  };


  const [indicadores, setIndicadores] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const indicadoresPorPagina = 10;



  useEffect(() => {

    setnameReport("Gestión de Indicadores");
    cargarIndicadores();
    window.dispatchEvent(new Event("storage_name"));

  }, []);

  useEffect(() => {

    if (
        mostrarModal &&
        modoEdicion &&
        indicadorEditar
    ) {

        Object.keys(indicadorEditar).forEach((campo) => {

            const elemento =
                document.getElementById(campo);

            if (elemento) {

                elemento.value =
                    indicadorEditar[campo] ?? "";

            }

        });

    }

}, [
    mostrarModal,
    modoEdicion,
    indicadorEditar
]);

useEffect(() => {
    setPaginaActual(1);
}, [busqueda]);

const indicadoresFiltrados = indicadores.filter((indicador) => {
    const texto = busqueda.toLowerCase().trim();

    if (!texto) return true;

    return (
        String(indicador.ID_INDICADOR || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.PERSPECTIVA || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.OBJETIVO_ESTRATEGICO || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.TITULO_INDICADOR || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.OBJETIVO_INDICADOR || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.DESCRIPCION || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.FUENTE_INFORMACION || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.DOMINIO || "")
            .toLowerCase()
            .includes(texto) ||

        String(indicador.DATA_OWNER || "")
            .toLowerCase()
            .includes(texto)
    );
});

    const totalPaginas = Math.ceil(
    indicadoresFiltrados.length / indicadoresPorPagina
    );

    const indiceInicio =
        (paginaActual - 1) * indicadoresPorPagina;

    const indicadoresPaginados = indicadoresFiltrados.slice(
        indiceInicio,
        indiceInicio + indicadoresPorPagina
    );

  const cargarIndicadores = async () => {

    try {

        setCargando(true);

        const response = await fetch("/api/indicadores");

        const resultado = await response.json();

        if (!response.ok) {
            throw new Error(
                resultado.message || "Error al consultar indicadores"
            );
        }

        setIndicadores(resultado.data || []);

    } catch (error) {

        console.error(
            "Error cargando indicadores:",
            error
        );

        alert(
            "No se pudieron cargar los indicadores."
        );

    } finally {

        setCargando(false);

    }
};
  
  const abrirEdicion = (indicador) => {

        setIndicadorEditar(indicador);
        setModoEdicion(true);
        setMostrarModal(true);

   };

  const guardarIndicador = async () => {

    const datos = {
        ID_INDICADOR: document.getElementById("ID_INDICADOR").value,
        PERSPECTIVA: document.getElementById("PERSPECTIVA").value,
        OBJETIVO_ESTRATEGICO: document.getElementById("OBJETIVO_ESTRATEGICO").value,
        TITULO_INDICADOR: document.getElementById("TITULO_INDICADOR").value,
        OBJETIVO_INDICADOR: document.getElementById("OBJETIVO_INDICADOR").value,
        DESCRIPCION: document.getElementById("DESCRIPCION").value,
        AUTOMATIZABLE: document.getElementById("AUTOMATIZABLE").value,
        FORMULA_TEXTO: document.getElementById("FORMULA_TEXTO").value,
        FRECUENCIA: document.getElementById("FRECUENCIA").value,
        NIVEL_INDICADOR: document.getElementById("NIVEL_INDICADOR").value,
        COMPARA_MEDICION: document.getElementById("COMPARA_MEDICION").value,
        FUENTE_INFORMACION: document.getElementById("FUENTE_INFORMACION").value,
        DOMINIO: document.getElementById("DOMINIO").value,
        DATA_OWNER: document.getElementById("DATA_OWNER").value,
        DATA_STEWARD: document.getElementById("DATA_STEWARD").value,
        UNIDAD_MEDIDA: document.getElementById("UNIDAD_MEDIDA").value,
        ESTADO_INDICADOR: document.getElementById("ESTADO_INDICADOR").value,
        TARGET: document.getElementById("TARGET").value,
        VERDE: document.getElementById("VERDE").value,
        AMARILLO: document.getElementById("AMARILLO").value,
        ROJO: document.getElementById("ROJO").value,
        OBJETIVO_5YP: document.getElementById("OBJETIVO_5YP").value,
        REPORTE: document.getElementById("REPORTE").value
    };

    if (!datos.ID_INDICADOR.trim()) {
        alert("El ID del indicador es obligatorio.");
        return;
    }

    try {

        const response = await fetch("/api/indicadores", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(datos)
        });

        const resultado = await response.json();

        if (!response.ok) {
            alert(resultado.message || "No se pudo guardar el indicador.");
            return;
        }

        alert("Indicador creado correctamente.");

        setMostrarModal(false);

        window.location.reload();

    } catch (error) {

        console.error(error);

        alert("Error de conexión con el servidor.");

    }
};

const actualizarIndicador = async () => {

    const datos = {
        ID_INDICADOR:
            document.getElementById("ID_INDICADOR").value,

        PERSPECTIVA:
            document.getElementById("PERSPECTIVA").value,

        OBJETIVO_ESTRATEGICO:
            document.getElementById("OBJETIVO_ESTRATEGICO").value,

        TITULO_INDICADOR:
            document.getElementById("TITULO_INDICADOR").value,

        OBJETIVO_INDICADOR:
            document.getElementById("OBJETIVO_INDICADOR").value,

        DESCRIPCION:
            document.getElementById("DESCRIPCION").value,

        AUTOMATIZABLE:
            document.getElementById("AUTOMATIZABLE").value,

        FORMULA_TEXTO:
            document.getElementById("FORMULA_TEXTO").value,

        FRECUENCIA:
            document.getElementById("FRECUENCIA").value,

        NIVEL_INDICADOR:
            document.getElementById("NIVEL_INDICADOR").value,

        COMPARA_MEDICION:
            document.getElementById("COMPARA_MEDICION").value,

        FUENTE_INFORMACION:
            document.getElementById("FUENTE_INFORMACION").value,

        DOMINIO:
            document.getElementById("DOMINIO").value,

        DATA_OWNER:
            document.getElementById("DATA_OWNER").value,

        DATA_STEWARD:
            document.getElementById("DATA_STEWARD").value,

        UNIDAD_MEDIDA:
            document.getElementById("UNIDAD_MEDIDA").value,

        ESTADO_INDICADOR:
            document.getElementById("ESTADO_INDICADOR").value,

        TARGET:
            document.getElementById("TARGET").value,

        VERDE:
            document.getElementById("VERDE").value,

        AMARILLO:
            document.getElementById("AMARILLO").value,

        ROJO:
            document.getElementById("ROJO").value,

        OBJETIVO_5YP:
            document.getElementById("OBJETIVO_5YP").value,

        REPORTE:
            document.getElementById("REPORTE").value
    };


    if (!datos.ID_INDICADOR.trim()) {

        alert(
            "El ID del indicador es obligatorio."
        );

        return;
    }


    try {

        const response = await fetch(
            `/api/indicadores/${encodeURIComponent(
                indicadorEditar.ID_INDICADOR
            )}`,
            {
                method: "PUT",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify(datos)
            }
        );


        const resultado =
            await response.json();


        if (!response.ok) {

            alert(
                resultado.message ||
                "No se pudo actualizar el indicador."
            );

            return;
        }


        alert(
            "Indicador actualizado correctamente."
        );


        setMostrarModal(false);
        setModoEdicion(false);
        setIndicadorEditar(null);

        cargarIndicadores();


    } catch (error) {

        console.error(error);

        alert(
            "Error de conexión con el servidor."
        );

    }

};


const eliminarIndicador = async (indicador) => {

    const confirmar = window.confirm(
        `¿Está seguro de desactivar el indicador "${indicador.TITULO_INDICADOR}"?`
    );

    if (!confirmar) {
        return;
    }

    try {

        const response = await fetch(
            `/api/indicadores/${encodeURIComponent(
                indicador.ID_INDICADOR
            )}`,
            {
                method: "DELETE"
            }
        );

        const resultado = await response.json();

        if (!response.ok) {

            alert(
                resultado.message ||
                "No se pudo desactivar el indicador."
            );

            return;
        }

        alert(
            "Indicador desactivado correctamente."
        );

        cargarIndicadores();

    } catch (error) {

        console.error(
            "Error desactivando indicador:",
            error
        );

        alert(
            "Error de conexión con el servidor."
        );

    }
};

const abrirFichaTecnica = (indicador) => {
    setIndicadorFicha(indicador);
    setMostrarFicha(true);
};

  return (

    <div>

      <Header
        user={user}
        onLogout={handleLogout}
      />

      <main
        style={{
          paddingTop: "25px",
          paddingLeft: "30px",
          paddingRight: "30px",
          paddingBottom: "30px"
        }}
      >

        <Card
          className="shadow-sm border-0"
          style={{
                    borderRadius: "10px",
                    maxHeight: "calc(100vh - 70px)",
                    overflowY: "auto",
                    overflowX: "hidden"
                }}
        >

          <Card.Body>

            {/* ENCABEZADO */}

            <div
              className="d-flex justify-content-between align-items-center mb-4"
            >

              <div>

                <h4
                  className="mb-1"
                  style={{
                    fontWeight: "700",
                    color: "#333"
                  }}
                >
                  Indicadores
                </h4>

                <small className="text-muted">
                  Administración de indicadores estratégicos
                </small>

              </div>


             <Button
                style={{
                    backgroundColor: "#cd2822",
                    borderColor: "#cd2822"
                }}
                onClick={() => {

                    setModoEdicion(false);
                    setIndicadorEditar(null);
                    setMostrarModal(true);

                }}
            >
                <FaPlus className="me-2" />
                Nuevo indicador
            </Button>

            </div>


            {/* BUSCADOR */}

            <div className="mb-3">

              <InputGroup
                style={{
                  maxWidth: "450px"
                }}
              >

                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>

                <Form.Control
                  type="text"
                  placeholder="Buscar indicador..."
                  value={busqueda}
                  onChange={(e) =>
                    setBusqueda(e.target.value)
                  }
                />

              </InputGroup>

            </div>


            {/* TABLA */}

            <div
              className="table-responsive indicadores-table-container"
            >

              <Table
                hover
                bordered
                className="align-middle"
              >

                <thead>

                  <tr
                    style={{
                      backgroundColor: "#cd2822",
                      color: "white"
                    }}
                  >

                    <th>ID</th>

                    <th>Dominio</th>

                    <th>Indicador</th>

                    <th>Frecuencia</th>

                    <th className="text-center">Estado</th>

                    <th
                      style={{
                        width: "150px",
                        textAlign: "center"
                      }}
                    >
                      Acciones
                    </th>

                  </tr>

                </thead>


                <tbody>

                {cargando ? (

                    <tr>
                        <td
                            colSpan="6"
                            className="text-center py-4"
                        >
                            Cargando indicadores...
                        </td>
                    </tr>

                ) : indicadoresFiltrados.length > 0 ? (

                    indicadoresPaginados.map((indicador) => (

                        <tr key={indicador.ID_INDICADOR}>

                            <td>
                                {indicador.ID_INDICADOR}
                            </td>

                            <td>
                                {indicador.DOMINIO}
                            </td>

                            <td>
                                <strong>
                                    {indicador.TITULO_INDICADOR}
                                </strong>
                            </td>

                            <td>
                                {indicador.FRECUENCIA}
                            </td>

                            <td className="text-center">

                                <span
                                    className="badge"
                                    style={{
                                        backgroundColor:
                                            indicador.ACTIVO
                                                ? "#198754"
                                                : "#6c757d"
                                    }}
                                >
                                    {indicador.ESTADO_INDICADOR}
                                </span>

                            </td>

                            <td className="text-center">
                                
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="me-2"
                                    title="Ficha técnica"
                                    onClick={() => abrirFichaTecnica(indicador)}
                                >
                                    📋
                                </Button>

                                {/*<Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => abrirEdicion(indicador)}
                                >
                                    <FaEdit />
                                </Button>

                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() =>
                                        eliminarIndicador(indicador)
                                    }
                                >
                                    <FaTrash />
                                </Button>*/}

                            </td>

                        </tr>

                    ))

                ) : (

                    <tr>

                        <td
                            colSpan="6"
                            className="text-center text-muted py-4"
                        >
                            No se encontraron indicadores
                        </td>

                    </tr>

                )}

            </tbody>

              </Table>

              <div className="d-flex justify-content-between align-items-center mt-3">

    <div className="text-muted">
        {indicadoresFiltrados.length > 0 ? (
            <>
                Mostrando{" "}
                <strong>{indiceInicio + 1}</strong>
                {" - "}
                <strong>
                    {Math.min(
                        indiceInicio + indicadoresPorPagina,
                        indicadoresFiltrados.length
                    )}
                </strong>
                {" de "}
                <strong>{indicadoresFiltrados.length}</strong>
                {" indicadores"}
            </>
        ) : (
            "No se encontraron indicadores"
        )}
    </div>

    <div className="d-flex align-items-center gap-2">

        <Button
            variant="outline-secondary"
            size="sm"
            disabled={paginaActual === 1}
            onClick={() =>
                setPaginaActual((prev) => prev - 1)
            }
        >
            ← Anterior
        </Button>

        <span className="fw-bold">
            Página {paginaActual} de {totalPaginas || 1}
        </span>

        <Button
            variant="outline-secondary"
            size="sm"
            disabled={
                paginaActual >= totalPaginas ||
                totalPaginas === 0
            }
            onClick={() =>
                setPaginaActual((prev) => prev + 1)
            }
        >
            Siguiente →
        </Button>

    </div>

</div>

            </div>

          </Card.Body>

        </Card>

      </main>

      <Modal
        show={mostrarModal}
        onHide={() => setMostrarModal(false)}
        size="xl"
        centered
        >
        <Modal.Header
            closeButton
            style={{
            backgroundColor: "#cd2822",
            color: "white"
            }}
        >
            <Modal.Title>
                {modoEdicion
                    ? "Editar Indicador"
                    : "Nuevo Indicador"}
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>

            {/* INFORMACIÓN GENERAL */}

            <h6
            className="mb-3"
            style={{
                color: "#cd2822",
                fontWeight: "700"
            }}
            >
            Información general
            </h6>

            <Row>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    ID Indicador *
                </Form.Label>

                <Form.Control
                    id="ID_INDICADOR"
                    type="text"
                    placeholder="Ej. IND001"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Perspectiva
                </Form.Label>

                <Form.Control
                    id="PERSPECTIVA"
                    type="text"
                    placeholder="Ej. Perspectiva"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Objetivo estratégico
                </Form.Label>

                <Form.Control
                    id="OBJETIVO_ESTRATEGICO"
                    type="text"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            </Row>


            <Row>

            <Col md={6}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Título del indicador
                </Form.Label>

                <Form.Control
                    id="TITULO_INDICADOR"
                    type="text"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Objetivo del indicador
                </Form.Label>

                <Form.Control
                    id="OBJETIVO_INDICADOR"
                    type="text"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            </Row>


            <Form.Group className="mb-4">

            <Form.Label>
                Descripción
            </Form.Label>

            <Form.Control
                id="DESCRIPCION"
                as="textarea"
                rows={3}
                maxLength={100}
            />

            </Form.Group>


            {/* CONFIGURACIÓN */}

            <h6
            className="mb-3"
            style={{
                color: "#cd2822",
                fontWeight: "700"
            }}
            >
            Configuración del indicador
            </h6>

            <Row>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Automatizado
                </Form.Label>

                <Form.Select id="AUTOMATIZABLE">
                    <option value="">
                    Seleccionar
                    </option>
                    <option value="SI">
                    Sí
                    </option>
                    <option value="NO">
                    No
                    </option>
                </Form.Select>
                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Frecuencia
                </Form.Label>

                <Form.Select id="FRECUENCIA">
                    <option value="">
                    Seleccionar
                    </option>
                    <option value="DIARIA">
                    Diaria
                    </option>
                    <option value="SEMANAL">
                    Semanal
                    </option>
                    <option value="MENSUAL">
                    Mensual
                    </option>
                    <option value="TRIMESTRAL">
                    Trimestral
                    </option>
                    <option value="SEMESTRAL">
                    Semestral
                    </option>
                    <option value="ANUAL">
                    Anual
                    </option>
                </Form.Select>
                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">
                <Form.Label>
                    Nivel indicador
                </Form.Label>

                <Form.Control
                    id="NIVEL_INDICADOR"
                    type="text"
                    maxLength={100}
                />
                </Form.Group>
            </Col>

            </Row>


            <Form.Group className="mb-3">

            <Form.Label>
                Fórmula
            </Form.Label>

            <Form.Control
                id="FORMULA_TEXTO"
                as="textarea"
                rows={2}
                placeholder="Ingrese la fórmula del indicador"
                maxLength={100}
            />

            </Form.Group>


            <Row>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Compara medición
                </Form.Label>

                <Form.Control
                    id="COMPARA_MEDICION"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Fuente información
                </Form.Label>

                <Form.Control
                    id="FUENTE_INFORMACION"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Dominio
                </Form.Label>

                <Form.Control
                    id="DOMINIO"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            </Row>


            {/* RESPONSABLES */}

            <h6
            className="mb-3 mt-3"
            style={{
                color: "#cd2822",
                fontWeight: "700"
            }}
            >
            Responsables
            </h6>

            <Row>

            <Col md={6}>

                <Form.Group className="mb-3">

                <Form.Label>
                    Data Owner
                </Form.Label>

                <Form.Control
                    id="DATA_OWNER"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            <Col md={6}>

                <Form.Group className="mb-3">

                <Form.Label>
                    Data Steward
                </Form.Label>

                <Form.Control
                    id="DATA_STEWARD"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            </Row>


            {/* MEDICIÓN */}

            <h6
            className="mb-3 mt-3"
            style={{
                color: "#cd2822",
                fontWeight: "700"
            }}
            >
            Medición y metas
            </h6>

            <Row>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Unidad de medida
                </Form.Label>

                <Form.Control
                    id="UNIDAD_MEDIDA"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Target
                </Form.Label>

                <Form.Control
                    id="TARGET"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            <Col md={4}>
                <Form.Group className="mb-3">

                <Form.Label>
                    Objetivo 5YP
                </Form.Label>

                <Form.Control
                    id="OBJETIVO_5YP"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>
            </Col>

            </Row>


            <Row>

            <Col md={4}>

                <Form.Group className="mb-3">

                <Form.Label>
                    🟢 Verde
                </Form.Label>

                <Form.Control
                    id="VERDE"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            <Col md={4}>

                <Form.Group className="mb-3">

                <Form.Label>
                    🟡 Amarillo
                </Form.Label>

                <Form.Control
                    id="AMARILLO"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            <Col md={4}>

                <Form.Group className="mb-3">

                <Form.Label>
                    🔴 Rojo
                </Form.Label>

                <Form.Control
                    id="ROJO"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            </Row>


            {/* PUBLICACIÓN */}

            <h6
            className="mb-3 mt-3"
            style={{
                color: "#cd2822",
                fontWeight: "700"
            }}
            >
            Publicación
            </h6>

            <Row>

            <Col md={6}>

                <Form.Group className="mb-3">

                <Form.Label>
                    Estado indicador
                </Form.Label>

                <Form.Select id="ESTADO_INDICADOR">

                    <option value="">
                    Seleccionar
                    </option>

                    <option value="ACTIVO">
                    Activo
                    </option>

                    <option value="INACTIVO">
                    Inactivo
                    </option>

                </Form.Select>

                </Form.Group>

            </Col>


            <Col md={6}>

                <Form.Group className="mb-3">

                <Form.Label>
                    Reporte
                </Form.Label>

                <Form.Control
                    id="REPORTE"
                    type="text"
                    maxLength={100}
                />

                </Form.Group>

            </Col>

            </Row>

        </Modal.Body>


        <Modal.Footer>

            <Button
            variant="secondary"
            onClick={() => setMostrarModal(false)}
            >
            Cancelar
            </Button>

            <Button
                style={{
                    backgroundColor: "#cd2822",
                    borderColor: "#cd2822"
                }}
                onClick={
                    modoEdicion
                        ? actualizarIndicador
                        : guardarIndicador
                }
            >
                {modoEdicion
                    ? "Guardar cambios"
                    : "Guardar indicador"}
            </Button>

        </Modal.Footer>

        </Modal>

        <Modal
    show={mostrarFicha}
    onHide={() => {
        setMostrarFicha(false);
        setIndicadorFicha(null);
    }}
    size="xl"
    centered
>
    <Modal.Header
        closeButton
        style={{
            backgroundColor: "#cd2822",
            color: "#FFFFFF"
        }}
    >
        <Modal.Title>
            Ficha técnica del indicador
        </Modal.Title>
    </Modal.Header>

    <Modal.Body
        style={{
            backgroundColor: "#FFFFFF",
            padding: "20px"
        }}
    >

        {indicadorFicha && (

            <div className="ficha-container">

            <table className="ficha">
    <colgroup>
        <col style={{ width: "11%" }} />
        <col style={{ width: "13%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "20%" }} />
    </colgroup>

    <tr>
        <th>PERSPECTIVA</th>
        <td>{indicadorFicha.PERSPECTIVA}</td>

        <th>OBJETIVO_ESTRATEGICO</th>
        <td colSpan="5">
            {indicadorFicha.OBJETIVO_ESTRATEGICO}
        </td>
    </tr>

    <tr>
        <th>TITULO_INDICADOR</th>
        <td>{indicadorFicha.TITULO_INDICADOR}</td>

        <th>OBJETIVO_INDICADOR</th>
        <td colSpan="5">
            {indicadorFicha.OBJETIVO_INDICADOR}
        </td>
    </tr>

    <tr>
        <th>ID_INDICADOR</th>
        <th colSpan="6">DESCRIPCION</th>
        <th>AUTOMATIZADO</th>

    </tr>

    <tr>
        <td>{indicadorFicha.ID_INDICADOR}</td>

        <td colSpan="6" className="descripcion wrap">
            {indicadorFicha.DESCRIPCION}
        </td>

        <td>{indicadorFicha.AUTOMATIZABLE}</td>
    </tr>

    <tr>
        <th colSpan="3">FORMULA_TEXTO</th>
        <th colSpan="3">FRECUENCIA</th>
        <th colSpan="3">NIVEL_INDICADOR</th>
    </tr>

    <tr>
        <td colSpan="3" className="formula wrap">
            {indicadorFicha.FORMULA_TEXTO}
        </td>

        <td colSpan="3">
            {indicadorFicha.FRECUENCIA}
        </td>

        <td colSpan="3">
            {indicadorFicha.NIVEL_INDICADOR}
        </td>
    </tr>

    <tr>
        <th colSpan="2">FUENTE_INFORMACION</th>
        <th colSpan="2">DOMINIO</th>
        <th colSpan="2">DATA_OWNER</th>
        <th colSpan="2">DATA_STEWARD</th>
    </tr>

    <tr>
        <td colSpan="2">
            {indicadorFicha.FUENTE_INFORMACION}
        </td>

        <td colSpan="2">
            {indicadorFicha.DOMINIO}
        </td>

        <td colSpan="2">
            {indicadorFicha.DATA_OWNER}
        </td>

        <td colSpan="2">
            {indicadorFicha.DATA_STEWARD}
        </td>
    </tr>

    <tr>
        <th>UNIDAD_MEDIDA</th>
        <th>ESTADO_INDICADOR</th>
        <th>TARGET</th>
        <th className="verde">VERDE</th>
        <th className="amarillo">AMARILLO</th>
        <th className="rojo">ROJO</th>
        <th colSpan="2">OBJETIVO_5YP</th>
    </tr>

    <tr>
        <td>{indicadorFicha.UNIDAD_MEDIDA}</td>

        <td>{indicadorFicha.ESTADO_INDICADOR}</td>

        <td>{indicadorFicha.TARGET}</td>

        <td>{indicadorFicha.VERDE}</td>

        <td>{indicadorFicha.AMARILLO}</td>

        <td>{indicadorFicha.ROJO}</td>

        <td colSpan="2">
            {indicadorFicha.OBJETIVO_5YP}
        </td>
    </tr>

    <tr>
        <th colSpan="4">COMPARA_MEDICION</th>
        <th colSpan="4">REPORTE</th>
    </tr>

    <tr>
        <td colSpan="4" className="comparacion wrap">
            {indicadorFicha.COMPARA_MEDICION}
        </td>

        <td colSpan="4" className="comparacion wrap">
            {indicadorFicha.REPORTE}
        </td>
    </tr>
</table>

   
    </div>

        )}

    </Modal.Body>

    <Modal.Footer>

        <Button
            variant="secondary"
            onClick={() => {
                setMostrarFicha(false);
                setIndicadorFicha(null);
            }}
        >
            Cerrar
        </Button>

    </Modal.Footer>

</Modal>

    </div>

  );
}